<ng-container *transloco="let t;">
  <div class="add-agency-modal">
    <div class="add-agency-modal__description">
      <p>{{ t('DataSharing.modal.add.content', { serviceName: serviceName }) }}</p>
    </div>

    <div class="add-agency-modal__chip-input" (click)="focusInput()">
      <span class="add-agency-modal__chip" *ngFor="let chip of chips; let i = index">
        {{ chip }}
        <span class="add-agency-modal__chip-remove" (click)="removeChip(i)">&times;</span>
      </span>
      <input #chipInput id="chipInput" class="add-agency-modal__input" type="text"
        [(ngModel)]="currentInput"
        [placeholder]="chips.length === 0 ? ('DataSharing.text.addAgencyPlaceholder' | transloco) : ''"
        (keydown)="onKeydown($event)" (blur)="commitInput()" />
    </div>

    <div class="add-agency-modal__actions">
      <button type="button" pButton [text]="true" (click)="cancel()">
        {{ t('Buttons.cancel') }}
      </button>
      <button type="button" pButton
        [disabled]="chips.length === 0 && currentInput.trim().length === 0" (click)="submit()">
        {{ t('Buttons.add') }}
      </button>
    </div>
  </div>
</ng-container>
